export const centsToDollar = (cents: number, fractionDigits = 2): string => {
  const dollars = (cents / 100).toFixed(fractionDigits)
  return `$${dollars}`
}

export const dollarToCents = (dollars: number): number => {
  return Math.round(dollars * 100)
}
